import { render, staticRenderFns } from "./myMemberCard.vue?vue&type=template&id=068e8aa2&scoped=true&"
import script from "./myMemberCard.vue?vue&type=script&lang=js&"
export * from "./myMemberCard.vue?vue&type=script&lang=js&"
import style0 from "./myMemberCard.vue?vue&type=style&index=0&id=068e8aa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068e8aa2",
  null
  
)

export default component.exports